<template>
  <Card class="mt-2">
    <template #title> Settings </template>
    <template #content>
      <div class="grid">
        <div class="field col-12 md:col-6 lg:col-4">
          <div>{{ required ? 'Required' : 'Not Required' }}</div>
          <InputSwitch v-model="required" />
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
          <div>File Type</div>
          <Select v-model="select" :options="items" :required="required"></Select>
        </div>
      </div>
    </template>
  </Card>
  <Divider></Divider>
  <Card>
    <template #title> Component </template>
    <template #content>
      <form class="mt-5" @submit.prevent="submitForm">
        <FileUpload :type="select" :required="required"></FileUpload>
      </form>
    </template>
  </Card>
  <Divider></Divider>
  <Card>
    <template #title> Output </template>
    <template #content>
      <p>{{ gender }}</p>
    </template>
  </Card>
  <p v-for="error of v.$errors" :key="error.$uid">
    {{ error.$message }}
  </p>
</template>
<script setup>
import { ref } from 'vue'
import FileUpload from '@/components/input/FileUpload.vue'
import Select from '@/components/input/Select.vue'
import useValidate from '@vuelidate/core'

const select = ref('')
const required = ref(true)
const gender = ref('')
const v = useValidate()
const items = [
  { label: 'Demographic', value: 'demographic' },
  { label: 'Nina Card Back', value: 'ninaCardBack' },
  { label: 'Nin Card Front', value: 'ninCardFront' },
  { label: 'ID Card Front', value: 'id_card_front' },
  { label: 'ID Card Back', value: 'id_card_back' },
  { label: 'ID Scan', value: 'id_scan' }
]
// const submitForm = async () => {
//   const result = await v.value.$validate()
//   if (result) {
//     alert('success')
//   } else {
//     alert('error')
//   }
// }
</script>
